//region block: pre-declaration
//endregion
function get_schemaCache(_this__u8e3s4) {
  return _this__u8e3s4.n2m_1;
}
//region block: exports
export {
  get_schemaCache as get_schemaCache3drvxe6e7799s,
};
//endregion

//# sourceMappingURL=JsonSchemaCache.mjs.map
